module.exports = __webpack_public_path__ + "img/floating-image-2@3x.f5c80520.png";